var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BookCategoryLayout',{attrs:{"category":_vm.category,"label":_vm.categoryLabel,"searcher":_vm.customSearcher || _vm.searcher,"show-extra":"","publications":_vm.userPublications,"sort-strategy":_vm.sortStrategy,"custom-counter":_vm.customCounter},on:{"change":_vm.filterChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }